import { render, staticRenderFns } from "./fieldDMMultiselect.vue?vue&type=template&id=17da85c4"
import script from "./fieldDMMultiselect.vue?vue&type=script&lang=js"
export * from "./fieldDMMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports